import { IWorkflowTemplateResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

export const useWorkflowTemplate = (workflowTemplateId: string) => {
  const url = `${BASE_URL}/${workflowTemplateId}`;

  const { data, error, isLoading, mutate } = useSWR<IWorkflowTemplateResponse>(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, isLoading, mutate };
};
